import Cookies from 'js-cookie'

export const GetCookie = (name) => {
    return Cookies.get(name)
}

export const GetCookieJSON = (name) => {
    return Cookies.getJSON(name);
}

export const SetCookie = (name, value, expires) => {
    Cookies.set(name, value, { expires: expires });
}

export const RemoveCookie = (name) => {
    Cookies.remove(name);
}